import React, { Component } from "react";
import EditEventFormTypeWrapper from "./EditEventFormTypeWrapper";

class EditEventFormInputType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            edit: false,
        };

        this.setEdit = this.setEdit.bind(this);
    }

    setEdit(edit) {
        this.setState({
            edit: edit,
        });
    }

    render() {
        const { headline, arrayOfIds, inputSettings, formValue } = this.props;

        return (
            <EditEventFormTypeWrapper headline={headline}>
                {arrayOfIds.map((id) => (
                    <div className="pm-content-info" key={id}>
                        <span className="text-small-regular">
                            {inputSettings[id].form_layout_field_label + ": "}
                        </span>
                        <span className="text-small-light">
                            {formValue[id]}
                        </span>
                    </div>
                ))}
            </EditEventFormTypeWrapper>
        );
    }
}

export default EditEventFormInputType;
